import { Component, OnInit } from '@angular/core';

import {
  ErrorStrings,
  ValidationPatterns,
} from 'src/app/constants/form.constants';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import {
  RedirectionParams,
  RedirectionService,
} from 'src/app/services/redirection/redirection.service';
import { NgbDateStruct, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CommonUtilService } from 'src/app/services/common/common-util.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-update-date-of-birth',
  templateUrl: './update-date-of-birth.component.html',
  styleUrls: ['./update-date-of-birth.component.scss'],
})
export class UpdateDateOfBirthComponent implements OnInit {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  user: User;
  redirectParams?: RedirectionParams;
  public dateOfBirthValue: NgbDateStruct;
  public today: NgbDate;
  public minDate: NgbDateStruct = { year: 1900, month: 1, day: 1 };
  public useRebrandedLayout: boolean;

  existingDateOfBirth: string;

  validationPatterns = ValidationPatterns;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private redirectionService: RedirectionService,
    private commonUtilService: CommonUtilService,
    private featureFlagService: FeatureFlagsService
  ) {
    this.user = this.route.snapshot.data.user as User;
     this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;
    this.userService
      .saveDatOfBirth(
        this.commonUtilService.createDateObject(this.dateOfBirthValue)
      )
      .subscribe({
        next: (updatedUser) => {
          this.user = updatedUser;
          this.existingDateOfBirth = this.getDateOfBirthString();
          form.controls.dateOfBirth.reset();
          this.loading = false;

          this.alert = {
            type: 'success',
            message: 'Your date of birth has been updated.',
          };

          if (this.redirectParams) {
            this.router.navigate(this.redirectParams.l, {
              queryParams: this.redirectParams.q,
              fragment: this.redirectParams.f,
            });
          }
        },
        error: (err) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'There was a problem updating your date of birth.',
            };
          } else {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        }
      })
  }

  getDateOfBirthString(): string {
    if (this.user.dateOfBirth) {
      const day = new Date(this.user.dateOfBirth).getDate();
      const month = new Date(this.user.dateOfBirth).getMonth() + 1;
      const year = new Date(this.user.dateOfBirth).getFullYear();
      return `${day}/${month}/${year}`;
    }

    return '-';
  }

  closeAlert() {
    this.alert = null;
  }

  ngOnInit(): void {
    this.existingDateOfBirth = this.getDateOfBirthString();

    // Setting redirection to be used when birth date is saved or when pressing back
    this.redirectParams = this.redirectionService.getParams(
      this.route.snapshot.queryParams.r
    );
  }
}
